import {
  RtWithProjectionPeriods,
  RtWithName,
  RtWithRelativesSet,
} from "@aprao/common/src/runtypes/common.js";
import { z } from "zod";

import { WithTimelineOverrideSchema } from "./TimelineStageSchema.js";

export const RtOtherCostKeys = z.enum([
  "absolute",
  "ratioBuildCostGlobalTotal",
  "ratioGdv",
]);

export const RtOtherCost = RtWithRelativesSet(RtOtherCostKeys)
  .merge(RtWithName)
  .merge(RtWithProjectionPeriods)
  .merge(WithTimelineOverrideSchema);

export const RtOtherCostsGroup = z.strictObject({
  name: z.string(),
  costs: z.array(RtOtherCost),
});
